import { gleecSocialLinks } from '@/data/configs/gleecSocialLinks';
import { siteData } from '@/data/configs/site';
import facebook from '@/public/img/community/socials/facebook.svg';
import instagram from '@/public/img/community/socials/instagram.svg';
import telegram from '@/public/img/community/socials/telegram.svg';
import twitter from '@/public/img/community/socials/twitter.svg';
import youtube from '@/public/img/community/socials/youtube.svg';

// Match the footer's social networks (excluding email) in both "Join the Best Blockchain Community" blocks.
export const communitySocialLinks = [
  { name: 'X.com', icon: twitter, link: siteData.social.twitter },
  { name: 'Telegram', icon: telegram, link: gleecSocialLinks.telegram },
  { name: 'Youtube', icon: youtube, link: gleecSocialLinks.youtube },
  { name: 'Facebook', icon: facebook, link: gleecSocialLinks.facebook },
  { name: 'Instagram', icon: instagram, link: gleecSocialLinks.instagram },
];
